/* eslint-disable */

const registrationNumRegex = /^[A-Za-z]{2}-[0-9]{2}-([0-9]{4}$|[a-zA-Z]{1,3}-[0-9]{4})$/

const BHRegistrationNumRegex =
  /^[1-9]{2}-[A-Z]{2}-[0-9]{4}-[A-Z]{2}$|[1-9]{2}-[A-Z]{2}-[0-9]{4}-[A-Z]{1}$/

const rtoNumRegex = /^[A-Za-z]{2}-[0-9]{2}$/
const BHrtoNumRegex = /^[0-9]{2}-[A-Z]{2}$|[0-9]{2}-[A-Z]{1}$/

const mobileNumRegex = /^[6-9]{1}[0-9]{9}$/

const mobileNumWithOptional91Regex = /^(91)?[6-9]\d{9}$/

const mobileNumWithOptional91AndPlus91Regex = /^(?:\+91|91)?[6789]\d{9}$/

const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

const panNumRegex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/

const panWithForm60Regex = /^(?:[A-Z]{5}[0-9]{4}[A-Z]|FORM60)$/

const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/

const pinCodeRegex = /^[1-9][0-9]{5}$/
const onlyAlphabetsRegex = /^[a-zA-Z]+$/

const alphabetsWithSpace = /^[A-Za-z\s]+$/

const startingWithSpaceNotAllowed = /^[^\s].*/

const alphabetWithoutSpace = /^[a-zA-Z]*$/

const startingWithSpaceNotOnlyAlphabetsRegex = /^[^-\s][a-zA-Z_\s-]+$/

const onlyAlphabetsWithSpaceRegex = /^[a-zA-Z ]*$/

const dotNotInclude = /^[^\.]*$/

const alphabetWithNumberRegex = /^[a-zA-Z0-9_.-]*$/

const numberWithoutDot = /^[+ -]?[0-9]{1,3}([.][0-9]{1,2})?$/

const onlyYearRegex = /^[12][0-9]{3}$/ // 1000 to 2999

const numberWithDecimal = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/

const addressRegex = /^[0-9a-zA-Z,#\/-][0-9a-zA-Z\s,#\/-]*$/

// addressRegex, but no two special characters in a row (e.g. "Flat---101")
const addressWithoutRepeatedSpecialCharsRegex = /^(?!.*[,#\/-]{2})[0-9a-zA-Z,#\/-][0-9a-zA-Z\s,#\/-]*$/

// alphabets, dot and space only; no leading or trailing space
const nameWithDotAndSpaceRegex = /^[a-zA-Z.](?:[a-zA-Z. ]*[a-zA-Z.])?$/

const startingWithSpaceAndNumberNotAllowed = /^(?!\s)[a-zA-Z\s]*$/

const passportNumberRegex = /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/
const bankAccountRegex = /^[0-9]{9,18}$/
const alphanumericBankAccountRegex = /^[a-zA-Z0-9]{9,18}$/
const bankIFSCRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/
const chassisNumberRegex = /^[A-HJ-NPR-Z0-9]{17}$/
const engineNumberRegex = /^[A-Za-z0-9]{6,17}$/



export {
  registrationNumRegex,
  mobileNumRegex,
  mobileNumWithOptional91Regex,
  mobileNumWithOptional91AndPlus91Regex,
  emailRegex,
  panNumRegex,
  gstRegex,
  pinCodeRegex,
  onlyAlphabetsRegex,
  startingWithSpaceNotAllowed,
  alphabetWithoutSpace,
  dotNotInclude,
  alphabetsWithSpace,
  alphabetWithNumberRegex,
  numberWithoutDot,
  onlyYearRegex,
  numberWithDecimal,
  startingWithSpaceNotOnlyAlphabetsRegex,
  onlyAlphabetsWithSpaceRegex,
  addressRegex,
  addressWithoutRepeatedSpecialCharsRegex,
  nameWithDotAndSpaceRegex,
  rtoNumRegex,
  BHRegistrationNumRegex,
  BHrtoNumRegex,
  panWithForm60Regex,
  startingWithSpaceAndNumberNotAllowed,
  passportNumberRegex,
  bankAccountRegex,
  alphanumericBankAccountRegex,
  bankIFSCRegex,
  chassisNumberRegex,
  engineNumberRegex
}
